import React from 'react'
import { useTranslation } from 'react-i18next'
import Slider from 'react-slick'

const Banner = () => {
  const { t } = useTranslation()

  const slides = [
    {
      img: 'https://images.unsplash.com/photo-1605296867304-46d5465a13f1?auto=format&fit=crop&w=800&q=80',
      text: t('banner.slide1'),
    },
    {
      img: 'https://images.pexels.com/photos/6941884/pexels-photo-6941884.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
      text: t('banner.slide2'),
    },
    {
      img: 'https://images.pexels.com/photos/3768913/pexels-photo-3768913.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
      text: t('banner.slide3'),
    },
  ]
  
  

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  return (
    <section className="banner">
      <div className="container">
        <div className="text-block">
          <h1>{t('banner.title')}</h1>
          <p>{t('banner.subtitle')}</p>
          {/* <a href="#buy" className="btn-primary">{t('banner.cta')}</a> */}
        </div>

        <Slider {...settings} className="banner-slider">
          {slides.map((slide, index) => (
            <div key={index} className="slide">
              <img src={slide.img} alt={`slide-${index}`} />
              <p className="caption">{slide.text}</p>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  )
}

export default Banner
